(function () {
  function normalize(value) {
    return String(value || "")
      .normalize("NFKC")
      .toLocaleLowerCase("ja")
      .replace(/[\s\-_./×*]+/g, "");
  }

  function init(root) {
    if (root.dataset.manualsReady === "true") return;
    root.dataset.manualsReady = "true";

    var input = root.querySelector("[data-manual-search]");
    var cards = Array.prototype.slice.call(root.querySelectorAll("[data-manual-card]"));
    var results = root.querySelector("[data-manual-results]");
    var empty = root.querySelector("[data-manual-empty]");
    var clear = root.querySelector("[data-manual-clear]");
    if (!input) return;

    function filterCards() {
      var query = normalize(input.value.trim());
      var visible = 0;

      cards.forEach(function (card) {
        var matches = !query || normalize(card.getAttribute("data-search")).indexOf(query) !== -1;
        card.hidden = !matches;
        if (matches) visible += 1;
      });

      if (results) {
        results.textContent = query
          ? visible + " 件の説明書が見つかりました"
          : visible + " 件の説明書を掲載しています";
      }
      if (empty) empty.hidden = visible !== 0;
    }

    input.addEventListener("input", filterCards);
    if (clear) {
      clear.addEventListener("click", function () {
        input.value = "";
        filterCards();
        input.focus();
      });
    }
    filterCards();
  }

  function start() {
    document.querySelectorAll("[data-manuals-root]").forEach(init);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start);
  } else {
    start();
  }
})();